export default function TestComplete() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      fontFamily: 'var(--font)',
    }}>
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 16,
        padding: '48px 40px',
        maxWidth: 520,
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 56, marginBottom: 20 }}>🎉</div>
        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.8rem',
          color: 'var(--accent)',
          marginBottom: 16,
        }}>Assessment Submitted</h1>
        <p style={{ color: 'var(--text2)', lineHeight: 1.7, maxWidth: 380, margin: '0 auto' }}>
          Thank you for completing your assessment. The recruitment team will review your answers and be in touch with you soon.
        </p>
        <div style={{ marginTop: 32, padding: '16px 20px', background: 'var(--bg3)', borderRadius: 'var(--radius-sm)', fontSize: 13, color: 'var(--text3)' }}>
          You may now close this window.
        </div>
      </div>
    </div>
  );
}
